import React, { useEffect, useState } from 'react';
import { sess_get, sess_post } from 'utils/HttpRequests';
import moment from 'moment';
import { toast } from 'react-toastify';
import Pagination from '../subLevel/Pagination';

export function SearchSection(props) {
  const [value, setValue] = useState('');
  const [key, setKey] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const searchHandler = (e) => {
    e.preventDefault();
    props.getInfo({
      value, key, from, to,
    });
  };

  let search = <div />;
  switch (key) {
    case 'created_at':
      search = (
        <>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label>From</label>
            <input
              type="date"
              style={{ marginRight: '50px' }}
              value={from}
              placeholder="search ..."
              onChange={(e) => setFrom(e.target.value)}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label>To</label>
            <input
              type="date"
              style={{ marginRight: '50px' }}
              value={to}
              placeholder="search ..."
              onChange={(e) => setTo(e.target.value)}
            />
          </div>
        </>
      );
      break;
    case 'status':
      search = (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label>Value</label>
          <select
            style={{ marginRight: '50px', height: '30px' }}
            onChange={(e) => setValue(e.target.value)}
          >
            <option>---select---</option>
            <option value="waitlist">Waitlist</option>
            <option value="waitdrop">Waitdrop</option>
          </select>
        </div>
      );
      break;
    default:
      search = (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label>Value</label>
          <input
            style={{ marginRight: '50px' }}
            value={value}
            placeholder="search ..."
            onChange={(e) => setValue(e.target.value)}
          />
        </div>
      );
      break;
  }

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', flexDirection: 'row', margin: '60px auto',
    }}
    >
      <form onSubmit={searchHandler} style={{ display: 'flex', alignItems: 'end' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label>Search By</label>
          <select
            style={{ marginRight: '50px', height: '30px' }}
            onChange={(e) => { setKey(e.target.value); setValue(''); setFrom(''); setTo(); }}
          >
            <option>---select---</option>
            <option value="status">Status</option>
            <option value="phone_number">Primary Number</option>
            <option value="created_at">Date</option>
          </select>
        </div>
        {search}
        <button className="btn btn-primary">Search</button>
      </form>
    </div>
  );
}

export function UsersTable(props) {
  const displayStatus = (status) => {
    switch (status) {
      case 'DROP':
        return 'Waitdrop';
      default:
        return 'Waitlist';
    }
  };

  return (
    <table style={{ tableLayout: 'auto' }}>
      <tr>
        <th>Status</th>
        <th>Number</th>
        <th>Date</th>
        <th>Action</th>
      </tr>
      <tbody>
        {props.data.length > 0
          && props.data.map((user) => (
            <tr key={user.phone_number}>
              <td>{displayStatus(user.status)}</td>
              <th>{user.phone_number}</th>
              <td>{user.created_at ? moment(user.created_at).format('DD-MM-YYYY') : ''}</td>
              <td>
                {!user.status
                && <button className="btn btn-danger" onClick={() => props.notifyHandler(user.phone_number)}>Notify</button>}
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}

export default function WaitingUsers() {
  const [data, setData] = useState({});
  const [error, setError] = useState('');
  const [currentPage, SetCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [value, setValue] = useState('');
  const [key, setKey] = useState('');
  const [fromDate, setFrom] = useState('');
  const [toDate, setTo] = useState('');
  const pageSize = 10;

  useEffect(() => {
    fetchData(currentPage, pageSize);
  }, []);

  const fetchData = (pageNo, pageSize, search_text, search_category, from, to) => {
    const searchData = {};
    if (pageNo) searchData.pageNo = pageNo;
    searchData.pageSize = (pageSize) || 10;
    if (search_text) {
      searchData.search_text = search_text;
      setValue(search_text);
    } else if (value !== '') searchData.search_text = value;
    if (search_category) {
      searchData.search_category = search_category;
      setKey(search_category);
    } else if (key !== '') searchData.search_category = key;
    if (from) {
      searchData.from = from;
      setFrom(from);
    } else if (from !== '') searchData.form = fromDate;
    if (to) {
      searchData.to = to;
      setTo(to);
    } else if (to !== '') searchData.to = toDate;
    console.log(searchData);
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    sess_get('admin/console/waitlist-users', session_token, searchData)
      .then((res) => {
        setData(res?.data?.response?.users);
        setLastPage(res?.data?.response?.totalPages);
        SetCurrentPage(res?.data?.response?.pageNo);
      })
      .catch((err) => { setError(err?.response?.data?.error?.reason || 'something went wrong'); });
  };

  const notifyHandler = (number) => {
    const data = {};
    if (number) { data.number = number; }
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    sess_post('admin/console/waitlist_to_waitdrop', session_token, data)
      .then((res) => {
        fetchData();
        toast.success('Notified to User(s)');
      })
      .catch((err) => { toast.error('Something went wrong'); });
  };

  return (
    <div style={{}}>

      <div style={{ textAlign: 'center', margin: '60px' }}>
        <h2>Waiting List Users</h2>
        <button className="btn btn-danger" onClick={notifyHandler}>Notify All</button>
      </div>
      <SearchSection getInfo={(data) => { fetchData(1, 10, data.value, data.key, data.from, data.to); }} />
      <UsersTable data={data} notifyHandler={(number) => notifyHandler(number)} />
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        margin: '30px',
      }}
      >

        <Pagination
          getInfo={(data) => { fetchData(data.pageNo); }}
          currentPage={currentPage}
          lastPage={lastPage}
        />
      </div>
    </div>
  );
}
